import type { ReferenceBuilderInput } from '@shared/reference-assets'
import type { PlaygroundRun } from '@shared/types'

/**
 * The selected run is polled while it is generating, while the history feed is
 * intentionally cached. Prefer that fresh record so the sidebar never shows a
 * completed asset beside an older pending run summary.
 */
export function mergeCurrentPlaygroundRun(timeline: PlaygroundRun[], currentRun?: PlaygroundRun): PlaygroundRun[] {
  const runsById = new Map(timeline.map((run) => [run.runId, run]))
  if (currentRun) runsById.set(currentRun.runId, currentRun)

  return [...runsById.values()].sort(
    (left, right) => new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime()
  )
}

/** Reopens a reference generation in the utility that created it; legacy runs use the shared builder. */
export function referenceBuilderRoute(kind?: ReferenceBuilderInput['kind']) {
  return kind === 'character-sheet'
    ? ('/tools/character-sheet' as const)
    : kind === 'scale-reference'
      ? ('/tools/scale-reference' as const)
      : ('/playground/reference-builder' as const)
}
